
import {Component, Vue, Watch} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";

@Component({
  components: {},
})
export default class PreviewUsers extends Vue {

  private currentUsers: any = [];
  private headers: object[] = [];
  private search: string = "";
  private loading: boolean = false;
  private saving: boolean = false;
  private rules: object = formRules;
  private legendDialog: boolean = false;

  private mounted() {
    this.headers = [
      {value: "informations", sortable: false},
      {value: "firstName", text: this.$t("user.firstName"), sortable: true},
      {value: "lastName", text: this.$t("user.lastName"), sortable: true},
      {value: "email", text: this.$t("user.email"), sortable: true},
      {value: "company", text: this.$t("user.company"), sortable: true},
      {value: "job", text: this.$t("user.job"), sortable: true},
      {value: "phone", text: this.$t("user.phone"), sortable: false},
    ];
    this.reset();
    if (!this.currentUsers || (this.currentUsers && this.currentUsers.length) === 0) {
      this.$router.push({name: "contacts"});
    }
  }

  private reset(): void {
    this.currentUsers = JSON.parse(JSON.stringify(this.$route.params.items));
  }

  // Reset one user property to the import value
  // If no property is specified, reset all user's properties to the import values
  private resetUserProperty(user: any, property?: string): void {
    if (property) {
      user.currentValues[property] = user.importValues[property];
      if (property === "email") {
        this.updateUserInfoByEmail(user);
      }
    } else {
      Object.keys(user.currentValues).forEach((prop) => {
        user.currentValues[prop] = user.importValues[prop];
      });
      this.updateUserInfoByEmail(user);
    }
  }

  // Called when the user edit a user's email inline : check for duplicates email in the import
  private checkDuplicates() {
    const usedMails = this.currentUsers.map((user) => user.currentValues.email);
    this.currentUsers.forEach((user) => {
      user.duplicate = usedMails.indexOf(user.currentValues.email) !== usedMails.lastIndexOf(user.currentValues.email);
      if (user.duplicate) {
        const firstOccurrence = usedMails.indexOf(user.currentValues.email);
        this.currentUsers[firstOccurrence].duplicate = false;
      }
    });
  }

  // Called when the user save a user's email inline : check for the new email backend
  private updateUserInfoByEmail(user: any): void {
    this.checkDuplicates();
    this.$store.dispatch("users/getExistingByEmail", {
      email: user.currentValues.email,
    }).then((data) => user.databaseValues = data?.userData);
  }

  private searchCurrentValues(value, search, item) {
    for (const key of Object.keys(item.currentValues)) {
      if (item.currentValues[key].includes(search)) {
        return true;
      }
    }
    return false;
  }

  private getChipColor(item: any, property: string): string {
    if (item.duplicate) {
      return "grey";
    } else if (item.databaseValues && !!item.databaseValues.activatedAt) {
      return "default";
    } else if (item.currentValues[property] !== item.importValues[property]) {
      return "warning";
    } else if (item.databaseValues && item.databaseValues[property] &&
      item.currentValues[property] !== item.databaseValues[property]) {
      return "blue";
    } else {
      return "default";
    }
  }

  private getChipTextColor(item: any, property: string): string {
    if (item.duplicate) {
      return "grey";
    } else if (item.databaseValues && !!item.databaseValues.activatedAt) {
      return "default";
    } else if (item.databaseValues && !!item.databaseValues[property] &&
      item.currentValues[property] !== item.databaseValues[property]) {
      return "blue";
    } else if (item.currentValues[property] !== item.importValues[property]) {
      return "warning";
    } else {
      return "default";
    }
  }

  private getDisabledTooltip(item: any, property: string): boolean {
    return (
      !(item.databaseValues && !item.databaseValues.activatedAt) ||
      !item.databaseValues[property] ||
      (item.currentValues[property] === item.databaseValues[property])
    );
  }

  private deleteUser(user): void {
    if (confirm(this.$t("user.deleteConfirmation").toString())) {
      const pos = this.currentUsers.map((u) => u.importId).indexOf(user.importId);
      this.currentUsers.splice(pos, 1);
    }
  }

  private importUsers(): void {
    this.saving = true;
    this.$store.dispatch("users/importUsers", {
      users: this.currentUsers,
      importType: this.$route.params.importType,
      companyId: this.$route.params.companyId,
    })
      .then((data) => {
        this.$router.push({name: this.$route.params.importType, params: {data}});
      })
      .catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      })
      .finally(() => {
        this.saving = false;
      });
  }

  private close() {
    this.legendDialog = false;
  }
}
